// src/api/salesPerf.js
import { apiGetJson } from "./http";

export function getPerfMonthDailyYoY() {
  return apiGetJson(`/api/performance/month_daily_yoy`);
}

export function getPerfYearMonthlyYoY() {
  return apiGetJson(`/api/performance/year_monthly_yoy`);
}

// NEW
export function getPerfSummaryMtd() {
  return apiGetJson(`/api/performance/summary_mtd`);
}

// NEW
export function getPerfPendingAging() {
  return apiGetJson(`/api/performance/pending_aging`);
}